module.exports = __webpack_public_path__ + "img/img-12.4c6376c3.png";